// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedCloudServices_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 5C7.51472 5 5.5 7.01472 5.5 9.5C5.5 9.69907 5.51287 9.89464 5.5377 10.086L5.64666 10.9257L4.83639 11.1716C3.19378 11.6701 2 13.1969 2 15C2 17.2091 3.79086 19 6 19H18.5C20.433 19 22 17.433 22 15.5C22 13.9556 20.999 12.6423 19.6076 12.1786L18.7602 11.8962L18.9456 11.0224C18.9811 10.8548 19 10.6801 19 10.5C19 9.11929 17.8807 8 16.5 8C16.1283 8 15.7782 8.08046 15.4637 8.22397L14.5365 8.6471L14.1311 7.71199C13.4384 6.1144 11.8482 5 10 5ZM3.5 9.5C3.5 5.91015 6.41015 3 10 3C12.3457 3 14.3995 4.24243 15.5421 6.10238C15.8513 6.03528 16.1718 6 16.5 6C18.9853 6 21 8.01472 21 10.5C21 10.5332 20.9996 10.5664 20.9989 10.5995C22.7795 11.5092 24 13.3611 24 15.5C24 18.5376 21.5376 21 18.5 21H6C2.68629 21 0 18.3137 0 15C0 12.5773 1.43522 10.492 3.50015 9.54429C3.50005 9.52954 3.5 9.51477 3.5 9.5Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedCloudServices is a generated icon component.
 */
let IconMedCloudServices = IconMedCloudServices_1 = class IconMedCloudServices extends IconBaseElement {
    render() {
        return html `${IconMedCloudServices_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedCloudServices.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedCloudServices = IconMedCloudServices_1 = __decorate([
    customElement('zui-icon-med-cloud-services')
], IconMedCloudServices);
export { IconMedCloudServices };
